import { FC } from "react";
import { ChevronRight } from "@mui/icons-material";
import { MenuBarProps } from "@Components/menuBar/MenuBar";
import classes from "./MenuLinks.module.scss";

export const MenuLinks: FC<MenuBarProps> = ({ menuLinks, onDataReceived }) => {
  const handleOnClick = (l2Menu: any): void => {
    onDataReceived(l2Menu);
  };

  return (
    <div className={classes["shop-by"]}>
      {menuLinks?.map((listItem: any) => (
        <div
          className={classes["list-items"]}
          data-testid="menu-list-item"
          onClick={() => handleOnClick(listItem)}
          key={listItem?.title}
        >
          <span className={classes["shop-by-link-label"]}>
            {listItem?.title}
          </span>
          <ChevronRight />
        </div>
      ))}
    </div>
  );
};
